module.exports = __webpack_public_path__ + "static/img/driblab.0038f31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/driblab.png
// module id = Fm44
// module chunks = 94